import * as React from "react";
const SVGComponent = ({ strokeColor = "#90EE90", ...props }) => (
  <svg
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    width="100%"
    height="100%"
    x="0px"
    y="0px"
    viewBox="0 0 60.4 95.3"
    style={{
      enableBackground: "new 0 0 60.4 95.3",
    }}
    xmlSpace="preserve"
    {...props}
  >
    <style type="text/css">
      {
        `\n\t.slfront_st0{fill:none;stroke:${strokeColor};stroke-width:0.679;stroke-linecap:round;stroke-linejoin:round;}\n\t.slfront_st1{fill:${strokeColor};stroke:${strokeColor};stroke-width:0.679;stroke-linecap:round;stroke-linejoin:round;}\n\t.slfront_st2{fill:none;stroke:${strokeColor};stroke-width:0.679;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:4.0017;}\n\t.slfront_st3{fill:none;stroke:${strokeColor};stroke-width:0.679;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:4.0015;}\n`
      }
    </style>
    <g id="Layer_2_00000096754795704138239950000009198641046438642357_">
      <g id="Layer_1_00000172431740290962118360000015549662040293192599_">
        <g id="Layer_1_00000176015738785268899610000008737900945278076292_">
          <g id="Layer_1_00000131364332075015321670000002665866631553461418_">
            <g>
              <path className="slfront_st0" d="M14.9,1.2c4.1,5.9,8.9,38.4,11.7,46.6c0,0-0.1,22.4,0,22.9c0-0.1-0.9,16.8-0.7,19.6" />
              <path className="slfront_st0" d="M22.4,94.4l17.2-20.9c0.7-10.1,7-24.9,10.3-28.4l-1.5-7.9" />
              <path className="slfront_st0" d="M48.4,37.2c-2.3-14.3-3.8-33.9-8.5-34.6" />
            </g>
          </g>
          <path className="slfront_st0" d="M46.1,22.9L4.7,50.3" />
        </g>
      </g>
      <g id="Layer_2_00000035516422123843372410000014161462676458171016_">
        <circle className="slfront_st1" cx="20" cy="61.3" r="0.5" />
        <path className="slfront_st0" d="M16.6,64.4l4.2-2.4c0.2-0.2,0.4-0.5,0.2-0.7l-0.5-0.7c-0.2-0.2-0.5-0.4-0.7-0.2l-4.1,2.4 c-0.2,0.2-0.4,0.5-0.2,0.7l0.5,0.7C16.1,64.5,16.3,64.5,16.6,64.4z" />
        <line className="slfront_st0" x1="18.8" y1="60.9" x2="19.8" y2="62.5" />
        <path className="slfront_st0" d="M43.4,41.2l4.1-2.3c0.2-0.2,0.4-0.5,0.2-0.7l-0.4-0.7c-0.2-0.2-0.5-0.4-0.7-0.2l-4.1,2.3 c-0.2,0.2-0.4,0.5-0.2,0.7l0.5,0.7C42.8,41.2,43.1,41.3,43.4,41.2z" />
        <circle className="slfront_st1" cx="46.7" cy="38.2" r="0.5" />
        <line className="slfront_st0" x1="45.5" y1="37.9" x2="46.4" y2="39.4" />
      </g>
      <path className="slfront_st0" d="M43.7,73.8l0.2-3.6c-1.6,2-3.9,2.9-4,3.2" />
      <path className="slfront_st0" d="M46.7,81.1l-6.4-1.5c-1.1-0.3-1.9-1.3-2-2.4l-0.1-1.6" />
      <path className="slfront_st0" d="M54.7,62.2c0,0,1.5-14.3-2.6-12.5c0,0-4.7,2.3-7.9,18.7c-0.8,3.6-0.5,6.7-0.1,8.7" />
      <path className="slfront_st0" d="M49.9,78.7c2.3-3.6,3.4-9.7,3.4-9.7l1.1-1.1c-0.2-0.8,0.2-6.3,0.5-8.4c0-0.3,0.2-0.8,0.2-1.1 c1.1-5.9,0.9-9.3-0.1-10.8c-0.2-0.3-0.5-2.8-0.5-3.1c-0.5-2.6,1.3-5.6,1.3-5.6c-0.3-5.7-4.1-16.1-5-17" />
      <ellipse transform="matrix(0.1474 -0.9891 0.9891 0.1474 -23.3825 105.0777)" className="slfront_st2" cx="49.3" cy="66.1" rx="11.7" ry="3.6" />
      <path className="slfront_st0" d="M52,50c0,0,3.6,8.2,1.3,19.2" />
      <ellipse transform="matrix(0.1279 -0.9918 0.9918 0.1279 -23.2182 107.3974)" className="slfront_st3" cx="49.5" cy="66.9" rx="2.5" ry="1" />
      <path className="slfront_st0" d="M44,76.7c0.2,1.4,2.2,8.2,6.2,1.5" />
    </g>
  </svg>
);
export default SVGComponent;
